export default "__VITE_ASSET__Q_encN4g__"